import {AbstractDictModel} from './abstract-dict.model';

export interface ServiceTypeModel extends AbstractDictModel {
  code: string;
  name: string;
  nameEn: string;
  id?: number;
}
